import { v4 } from 'uuid';
import { createDurationTracker, } from '../duration-tracker';
class GlobalConfigImpl {
    constructor() {
        this.sessionId = '';
        this.reporter = null;
        this.batchQueue = null;
        this.durationTracker = createDurationTracker();
        this.state = new Map();
        this.sessionStart = Date.now();
    }
    getSessionId() {
        this.sessionId = this.sessionId || v4();
        return this.sessionId;
    }
    getSessionTime() {
        return Date.now() - this.sessionStart;
    }
    getReporter() {
        return this.reporter;
    }
    setReporter(reporter) {
        this.reporter = reporter;
    }
    initBatchQueue(batchQueue) {
        var _a;
        this.batchQueue = (_a = this.batchQueue) !== null && _a !== void 0 ? _a : batchQueue;
    }
    getBatchQueue() {
        return this.batchQueue;
    }
    getDurationTracker() {
        return this.durationTracker;
    }
    getStateValue(key) {
        return this.state.get(key);
    }
    setStateValue(key, value) {
        this.state.set(key, value);
    }
    clearState() {
        this.state.clear();
        this.durationTracker = createDurationTracker();
    }
}
export const createGlobalConfig = () => new GlobalConfigImpl();
//# sourceMappingURL=global-config.js.map